import { gql, TypedDocumentNode } from '@apollo/client'
import { employeesSidebarEmployeeFragment } from './employeesSidebarEmployeeFragment'
import type {
  SuEmployeesSidebarQuery,
  SuEmployeesSidebarQueryVariables
} from './__generated__/SuEmployeesSidebarQuery'

export const suEmployeesSidebarQuery: TypedDocumentNode<
  SuEmployeesSidebarQuery,
  SuEmployeesSidebarQueryVariables
> = gql`
  ${employeesSidebarEmployeeFragment}

  query SuEmployeesSidebarQuery(
    $name: String
    $phone: String
    $cursor: String
  ) {
    suEmployees(name: $name, phone: $phone, after: $cursor) {
      edges {
        node {
          ...EmployeesSidebarEmployeeFragment
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`
